export default __webpack_public_path__ + "static/O0306-d404435b26e9adbb9737e23e30422b70.png";